"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Category = void 0;
/** Matches `project_category` enum as it exists in Wordpress (tier 1) */
var Category;
(function (Category) {
    Category["TreePlanting"] = "tree_planting";
    Category["CarbonAvoidance"] = "carbon_avoidance";
    Category["CarbonRemoval"] = "carbon_removal";
    Category["HabitatRestoration"] = "habitat_restoration";
    Category["Marine"] = "marine";
})(Category = exports.Category || (exports.Category = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvamVjdC1jYXRlZ29yaWVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3Byb2plY3RzL3Byb2plY3QtY2F0ZWdvcmllcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSx5RUFBeUU7QUFDekUsSUFBWSxRQU1YO0FBTkQsV0FBWSxRQUFRO0lBQ2xCLDBDQUE4QixDQUFBO0lBQzlCLGdEQUFvQyxDQUFBO0lBQ3BDLDRDQUFnQyxDQUFBO0lBQ2hDLHNEQUEwQyxDQUFBO0lBQzFDLDZCQUFpQixDQUFBO0FBQ25CLENBQUMsRUFOVyxRQUFRLEdBQVIsZ0JBQVEsS0FBUixnQkFBUSxRQU1uQiJ9